import type { TAxiosRequestConfig } from '../ReactQuery.type';

/**
 * Converts input data to FormData if the Content-Type is 'multipart/form-data'.
 *
 * @param contentType - The value of the 'Content-Type' header
 * @param data - Input data to potentially convert
 * @returns Converted data (FormData if applicable, otherwise the original data)
 */

export const handleFormDataConversion = (
  contentType?: string,
  data?: TAxiosRequestConfig['data']
): FormData | TAxiosRequestConfig['data'] => {
  const shouldConvertToFormData =
    contentType === 'multipart/form-data' && Boolean(data);

  if (shouldConvertToFormData) {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      // * Handle nested objects or arrays if needed
      if (value instanceof File) {
        formData.append(key, value); // * Handle File objects directly
      } else if (typeof value === 'object' && value !== null) {
        formData.append(key, JSON.stringify(value)); // * Convert objects to JSON strings
      } else {
        formData.append(key, value as string); // * Default case for strings, numbers, etc.
      }
    });
    return formData;
  }
  return data;
};
